import { Link } from "react-router-dom";
import HeroIcon from "./HeroIcon";
import { ExternalLinkIcon } from "@heroicons/react/outline";

interface Props {
  icon: string;
  name: string
  href: string;
  isExpanded: boolean;
  isSelected: boolean;
  isHidden?: boolean;
  isExternal?: boolean;
}

function SidebarItem(props: Props) {
  if (props.isHidden)
    return null;

  return (
    <Link to={props.isExternal ? { pathname: props.href } : props.href} className={`group relative flex items-center gap-2 font-semibold px-3 py-2 mx-4 rounded-md cursor-pointer text-gray-600 ${props.isSelected ? 'bg-gray-50 hover:bg-gray-50' : ' hover:bg-gray-50'}`} target={props.isExternal ? "_blank" : ""}>
      <div className={`absolute bg-blue left-0 h-full w-1 rounded-l ${props.isSelected ? 'visible' : 'invisible'}`}></div>
      <HeroIcon icon={props.icon} className='w-5 h-5' />
      {props.isExpanded
        ? <div className="flex items-center gap-1 text-sm leading-none text-gray-900">{props.name}{props.isExternal && <ExternalLinkIcon className="w-4 h-4" />}</div>
        : <div className={`flex items-center gap-1 invisible group-hover:visible text-sm absolute left-8 text-gray-900 text-nowrap p-2 pl-2 pr-4 rounded bg-gray-50`}>{props.name}{props.isExternal && <ExternalLinkIcon className="w-4 h-4" />}</div>
      }

    </Link>
  );
};

export default SidebarItem;
